import { Table, type TableProps } from "antd";
import styled from "styled-components";
import { analyticsTheme } from "./analyticsTheme";

/**
 * An antd table drawn like the analytics handoff: white rows, a light header
 * in small uppercase, thin row separators and no outer border.
 */
export function AnalyticsTable<T extends object>(props: TableProps<T>) {
  return (
    <StyledFrame>
      <Table<T> size="small" pagination={false} {...props} />
    </StyledFrame>
  );
}

// ─── Styled components ───

const StyledFrame = styled.div`
  .ant-table,
  .ant-table-tbody > tr > td {
    background: ${analyticsTheme.cardBg};
  }

  .ant-table-thead > tr > th {
    background: #fbfcfd;
    padding: 10px 12px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    white-space: nowrap;
    color: ${analyticsTheme.textLabel};
    border-bottom: 1px solid ${analyticsTheme.barTrack};

    &::before {
      display: none;
    }
  }

  .ant-table-tbody > tr > td {
    padding: 10px 12px;
    font-size: 13px;
    font-variant-numeric: tabular-nums;
    vertical-align: top;
    border-bottom: 1px solid ${analyticsTheme.barTrack};
  }

  .ant-table-tbody > tr.ant-table-row:hover > td {
    background: #fafafa;
  }
`;
